<template>
  <div class="calendar_container">
    <calendar-header />
    <calendar-body
      :month="month"
      :year="year"
      :month-data="monthData"
      :month-relative="monthRelative"
      :days-in-month="daysInMonth"
      :selected-item-id="selectedItemId"
      @click-item-body="handleClickItemBody"
    />
  </div>
</template>

<script>
import CalendarHeader from './calendar-header';
import CalendarBody from './calendar-body';
import { component } from '../../../mixins/component';
import dayjs from '../../../utils/dayjs';
const _chunk = require('lodash.chunk');

const NUMBER_CALENDAR_BOX = 42;

export default {
  components: { CalendarBody, CalendarHeader },
  mixins: [component],
  props: {
    handleClickOnDay: {
      type: Function,
      default: () => {},
    },
    handleClickOnItem: {
      type: Function,
      default: () => {},
    },
    handleGetDataForMonth: {
      type: Function,
      default: () => {},
    },
    day: {
      type: Number,
      default: () => {
        return (new Date()).getDate();
      },
    },
    month: {
      type: Number,
      default: () => {
        return (new Date()).getMonth() + 1;
      },
    },
    year: {
      type: Number,
      default: () => {
        return (new Date()).getFullYear();
      },
    },
    selectedItemId: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    timezone: {
      type: String,
      default: () => {
        return this.guessTimezone();
      },
    },
    game: {
      type: String,
      default: () => {
        return 'all';
      },
    },
  },
  data() {
    return {
      monthData: {},
      daysInMonth: [],
      monthRelative: [],
      startTime: '',
      endTime: '',
    };
  },
  watch: {
    month: async function(newVal, oldVal) {
      await this.getDaysInMonthForCalendar(newVal, this.year);
      this.initMonthData();
    },
    game: async function(newVal, oldVal) {
      await this.initMonthData();
      const imgs = document.getElementsByClassName('calendar_body_day_item_img');
      for (let i = 0; i < imgs.length; i++) {
        imgs[i].classList = 'calendar_body_day_item_img lazyload';
      }
    },
  },
  async created() {
    await this.getDaysInMonthForCalendar(this.month, this.year);
    this.initMonthData();
  },
  methods: {
    async initMonthData() {
      const response = await this.handleGetDataForMonth(this.startTime, this.endTime, this.month, this.year, this.game);
      this.monthData = response.month_data;
      this.$emit('update-list-data', response.list_event_calendar, response.extend_day, this.monthData, response.current_event_id);
    },
    handleClickItemBody(data) {
      this.handleClickOnItem(data);
    },
    countDaysInMonth(month, year) {
      const date = new Date(year, month, 0);
      return date.getDate();
    },
    getFirstDayOfWeekAInMonth(month, year) {
      const date = new Date(year, month - 1, 0);
      return date.getDay();
    },
    getDaysInMonthForCalendar(month, year) {
      const arrDays = [];
      const countDaysInCurrentMonth = this.countDaysInMonth(month, year);
      const countDaysInPreviousMonth = this.countDaysInMonth(month - 1, year);
      var arrMonths = [];
      let getFirstDayOfWeekInCurrentMonth = this.getFirstDayOfWeekAInMonth(month, year);
      if (getFirstDayOfWeekInCurrentMonth === 0) {
        getFirstDayOfWeekInCurrentMonth = 7;
      }

      // push days of previous month
      for (let i = getFirstDayOfWeekInCurrentMonth; i >= 0; i--) {
        arrDays.push(countDaysInPreviousMonth - i);
        var previousMonth = (month - 1 === 0) ? 12 : (month - 1);
        previousMonth = previousMonth < 10 ? '0' + previousMonth : previousMonth;
        var previousYear = (month - 1 === 0) ? (year - 1) : year;
        arrMonths.push(previousYear + '-' + previousMonth);

        if (i === getFirstDayOfWeekInCurrentMonth) {
          this.startTime = dayjs(new Date(previousYear, previousMonth - 1, countDaysInPreviousMonth - i)).format('YYYY-MM-DD hh:mm A');
        }
      }
      // push days of current month
      for (let i = 1; i <= countDaysInCurrentMonth; i++) {
        arrDays.push(i);
        var currentMonth = month < 10 ? '0' + month : month;
        arrMonths.push(year + '-' + currentMonth);
      }
      const lengthArrDays = arrDays.length;
      // push days of next month
      for (let i = 1; i <= NUMBER_CALENDAR_BOX - lengthArrDays; i++) {
        arrDays.push(i);
        var nextMonth = (month + 1 === 13) ? 1 : (month + 1);
        nextMonth = nextMonth < 10 ? '0' + nextMonth : nextMonth;
        var nextYear = (month + 1 === 13) ? (year + 1) : year;
        arrMonths.push(nextYear + '-' + nextMonth);
        if (i === NUMBER_CALENDAR_BOX - lengthArrDays) {
          this.endTime = dayjs(new Date(nextYear, nextMonth - 1, NUMBER_CALENDAR_BOX - lengthArrDays)).format('YYYY-MM-DD hh:mm A');
        }
      }
      /* this.startTime = dayjs(new Date(year, month - 1, 1)).format('YYYY-MM-DD hh:mm A');
      this.endTime = dayjs(new Date(year, month - 1, countDaysInCurrentMonth)).format('YYYY-MM-DD hh:mm A');*/

      this.daysInMonth = _chunk(arrDays, 7);
      this.monthRelative = _chunk(arrMonths, 7);
    },
  },
};
</script>
